import React from "react";
import "./index.css";

export default function Index() {
  return (
    <div>
      {/* 内容 */}
      <div className="third news_list">
        <div className="Title">
          <div className="tit_a">成为一个受人尊敬的数字科技公司</div>
          <div className="tit_b">A Respected Digital Tech Company for Smart Industry</div>
        </div>
        <h2>企业文化</h2>
        <div className="xian"></div>
        <div className="en">Corporate Culture</div>
        <div className="company_content">
          <p>
            <b>公司简介：</b>
          </p>
          <br></br>
          <div className="zhengwen">
            <p>
              杭州中网智慧科技有限公司坐落于中国钱塘江畔的杭州国家高新技术产业开发区，在杭州滨江区和萧山区分别设有办公区，是中国领先的互联网、物联网、工业互联网智慧技术，计算机软件技术，智慧系统项目实施和数据运维技术整体解决方案提供商。
            </p>
            <p>
              致力于数字科技、信息安全、人工智能和新一代互联网智慧技术等领域的科学研究、技术开发和学术交流。依托浙江大学、浙江工业大学强大的科研和技术力量，形成了产学研一体的中国网络智慧技术研发、实施、管理和服务的卓越能力。
            </p>
            <p>
              公司是华为企业端产品战略合作分销与服务提供商，是中控蓝卓工业互联网与海康威视软件实施生态合作伙伴，是全国碳达峰、碳中和行业技术发展研究机构，并为多家业内著名企业、上市公司、科研单位、业务公司提供软件技术开发和实施服务。公司紧密适应数字经济、智慧城市、智能工厂等发展的新时代高质量发展要求，公司已在智慧信息系统设计、开发、集成和测试，智能服务终端软硬件开发等方面具备了一定的技术基础、丰富的实践经验和先进的技术研发能力。
            </p>
            <p>
              公司拥有高级工程师、高级经济师等技术和管理人员，核心团队层由知名上市公司高管及行业专家组成，重点发展工业应用软件技术开发、智慧系统供应链流程开发，信息系统项目实施、运维技术咨询服务等，公司丰富的项目运营和开拓经验，获得了党政机关、公共机构、互联网企业以及个人客户的广泛好评。
            </p>
            <br></br>
            <div className="english">
              <p className="english">
                Hangzhou Cnetwis Technology Co., Ltd. is located in Hangzhou
                National High-tech Industrial Development Zone beside the
                Qiantang River, China. It has offices in Binjiang District and
                Xiaoshan District respectively. It is a leading integrated
                solution provider of Internet, Internet of Things, industrial
                Internet intelligent technology, computer software technology,
                intelligent system project implementation and data operation and
                maintenance technology in China.
              </p>
              <p>
                It is committed to scientific research, technology development
                and academic exchange in the fields of digital technology,
                information security, artificial intelligence and the new
                generation of Internet intelligent technology. Relying on the
                strong scientific research and technical strength of Zhejiang
                University and Zhejiang University of Technology, it has formed
                the outstanding ability of research and development,
                implementation, management and service of Chinese network
                intelligent technology integrated with production, study and
                research.
              </p>
              <p>
                The company is a strategic cooperative distribution and service
                provider of Huawei enterprise products, an ecological partner of
                Lanzhuo Industrial Internet software implementation, a national
                carbon peak and carbon neutral industry technology development
                research institution, and provides software technology
                development and implementation services for many famous
                enterprises, listed companies, scientific research institutions
                and business companies in the industry. The company closely
                adapt to the digital economy, smart city, smart factory and
                other development of the new era of high-quality development
                requirements, the company has a certain technical foundation in
                the design, development, integration and testing of intelligent
                information system, intelligent service terminal hardware and
                software development and other aspects, rich practical
                experience and advanced technology research and development
                capabilities.
              </p>
              <p>
                The company has senior engineers, senior economists and other
                technical and managerial personnel, the core team is composed of
                well-known listed company executives and industry experts,
                focusing on the development of industrial application software
                technology, intelligent system supply chain process development,
                information system project implementation, operation and
                maintenance technology consulting services, etc. The company has
                rich experience in project operation and development. It has
                been widely praised by Party and government organs, public
                institutions, Internet enterprises and individual customers.
              </p>
            </div>
          </div>
          <br></br>
          <p>
            <b>企业使命：</b>
          </p>
          <br></br>
          <div className="zhengwen">
            <p>担当中国式现代化和新质生产力建设。</p>
            <br></br>
            <p className="english">
            It is responsible for the construction of Chinese-style modernization and new quality productive forces
            </p>
          </div>
          <br></br>
          <p>
            <b>核心价值观：</b>
          </p>
          <br></br>
          <div className="zhengwen">
            <p>学习创造价值。</p>
            <br></br>
            <p className="english">Learning to create value.</p>
          </div>
          <br></br>
          <p>
            <b>企业愿景：</b>
          </p>
          <br></br>
          <div className="zhengwen">
            <p>成为中国优秀的工业互联网数字智慧技术服务提供商。</p>
            <br></br>
            <p className="english">
              To become an excellent industrial Internet digital intelligence
              technology service provider in China.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
